// ---------------------------------------------------------------------------------------------
// EPOD independent dealer flow - UI side. See ashokleyland_node/services/epodDealerKey.js for the
// full explanation.
//
// An LR stamped epod_dealer_mode === 'independent' at delivery is open to the dealer as soon as it
// is delivered: its dealer / AL / document track never waits on the e-POD upload, the late-upload
// gate or OCR. Every other LR (all LRs delivered before the flag was switched on) keeps the original
// gate-status rules below, unchanged.
//
// For an independent row the BACKEND says whether the dealer can act (awaiting_dealer_confirmation,
// computed in dealerConfirmationService.listQueue) - the UI never re-derives it. Centralized here so
// epodScreen.js / dealerConfirmationScreen.js / dealerConditionActions.js never grow divergent copies.
// ---------------------------------------------------------------------------------------------

export function isIndependentRow(row) {
    return !!row && row.epod_dealer_mode === 'independent';
}

// Is this dealer-queue row currently open for Clean / Shortage / Damage?
export function isAwaitingDealer(qrow) {
    if (!qrow) return false;
    if (isIndependentRow(qrow)) return qrow.awaiting_dealer_confirmation === true;
    return ['cleared', 'late_approved'].indexOf(qrow.epod_gate_status) !== -1;
}

// The sequence a dealer-side reopen tracker (qrow.dealer_confirmation_reopen.upload_seq) is keyed to:
// the backend's dealer_seq for an independent row, the e-POD upload_seq for every other row.
export function dealerSeqOf(qrow) {
    if (isIndependentRow(qrow) && qrow.dealer_seq !== undefined) return qrow.dealer_seq;
    return qrow.epod_gate && qrow.epod_gate.upload_seq;
}
